/**
 * Avatar helpers — deterministic initials + brand-palette colour from a seed.
 * Mirrors `avColor` / `initials` from the design handoff (`data.jsx`).
 */
const AV_COLORS = ['#1D4289', '#34518C', '#5A6B8C', '#B0863C', '#43618F', '#7D6A44'] as const

export function avColor(seed: string): string {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 997
  return AV_COLORS[h % AV_COLORS.length]
}

export function initials(name: string): string {
  const p = name.trim().split(/\s+/)
  return ((p[0]?.[0] || '') + (p[1]?.[0] || '')).toUpperCase()
}
